import EventModel from '../event/event-model';
import QuizquestionModel from '../quizquestion/quizquestion-model';
import QuizanswerModel from '../quizanswer/quizanswer-model';

export default class EventquizModel {
    id: number;
    name: string;
    description: string;
    status: string;
    event: any;
    eventCaption: string;
    section: any;
    quizquestion: any;
    questionCaption: string;
    questionType: string;
    questionTypeCaption: string;
    questionTitle: string;
    quizanswer: any;
    quizanswerCaption: string;
    quizanswerLength: number;
    quizanswerTotal: number;
    answer: string;
    answered: number;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let event = datarow.event?.data? new EventModel(datarow.event?.data) : datarow.event;
        this.event = event?.id;
        this.eventCaption = event?.name;
        this.section = event?.section?.data?.[0]?.id;
        let questions = datarow.quizquestion?.data? new QuizquestionModel(datarow.quizquestion?.data) : datarow.quizquestion;
        this.quizquestion = questions?.id;
        this.questionCaption = questions?.name;
        this.questionType = questions?.type;
        this.questionTypeCaption = QuizquestionModel.optionType.filter((d: any) => d.name === this.questionType)?.[0]?.caption|| 'Yes or No';
        this.questionTitle = questions?.title ;
        this.quizanswer = datarow.quizanswer?.data?.map((d: any) => new QuizanswerModel(d));
        this.quizanswerLength = this.quizanswer?.length || (datarow.answer? 1 : 0);
        this.quizanswerCaption = this.quizanswerLength===0? '' : this.quizanswer?.[0].name + (this.quizanswerLength>1? ', ...' : '');
        this.quizanswerTotal = this.quizanswer?.reduce((v: number, d: any) => { return v + d.value; }, 0);
        this.answer = datarow.answer;
        this.answered = this.quizanswerLength > 0? 1 : 0;
    } 

    public static endPoint: string = 'event-quizes';
    public static endPointFilter: string = '?populate[event][populate]=section&populate[quizquestion][populate]=image&populate[quizanswer][sort]=seq&filters[id]=';
    public static endPointFilter2 = (quizquestionId?: number, eventId?: number) => {
        return '?populate[event][populate]=section&populate[quizanswer][sort]=seq&filters[quizquestion]=' + quizquestionId + '&filters[event]=' + eventId;
    }
    public static endPointFilterList = (eventId: number) => {
        return '?populate[event][populate]=section&populate[quizquestion][sort]=seq&filters[event]=' + eventId;
    }
    public static url: string = '/eventquiz';
    public static caption: string = 'Event Quiz';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active', 
        event: null,
        eventCaption: '',
        section: null,
        quizquestion: null,
        questionCaption: '',
        questionType: '',
        questionTypeCaption: '',
        questionTitle: '',
        quizanswer: [],
        quizanswerCaption: '',
        quizanswerLength: 0,
        quizanswerTotal: 0,
        answer: '',
        answered: 0,
        }
    }
    
    public static columns = [
        { name: 'questionCaption', caption: 'Name' },
        { name: 'questionTitle', caption: 'Title' },
        { name: 'questionTypeCaption', caption: 'Type' },
    ]

    public static columnPicklistUser = [
        { name: 'questionCaption', caption: 'Quizquestion' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}